import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';
import { ButtonTextEnum } from '@app/shared/models/button-text.model';
import { SharedModule } from '@app/shared/shared.module';
import { PlanManagerService } from '@app/plan-manager/plan-manager.service';

import { DesktopSearchContainerComponent } from '../../search/desktop-search-container/desktop-search-container.component';
import { SearchService } from '../../search/search.service';
import { NavigationComponentsService } from '../navigation-components.service';

import { HeaderNavigationComponent } from './header-navigation/header-navigation.component';
import { MenuState } from './header.model';
import { HeaderService } from './header.service';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    SharedModule,
    AngularMaterialCommonModule,
    HeaderNavigationComponent,
    ProfileMenuComponent,
    DesktopSearchContainerComponent
  ]
})
export class HeaderComponent {
  buttonTextEnum = ButtonTextEnum;

  @Input() nameInitials: string;
  menuState$: Observable<MenuState>;

  profileMenuItems$ = this.navigationComponentsService.profileMenuItems$;

  constructor(
    private headerService: HeaderService,
    private planManagerService: PlanManagerService,
    private navigationComponentsService: NavigationComponentsService,
    private searchService: SearchService
  ) {
    this.menuState$ = this.headerService.getMenuState;
  }

  get selectedPlanData$() {
    return this.planManagerService.getSelectedPlanData;
  }

  public toggleMenuVisibility(state: boolean): void {
    this.headerService.toggleMenuVisibility(state);
  }

  public navigateTo(url: string): void {
    this.headerService.navigateTo(url);
  }

  openSearchContainer() {
    this.searchService.isDesktopSearchContainerOpened.next(true);
  }
}
